import { resolveCanonicalCourseCode } from 'store/curriculumCourseManager/operations'
import { resolveDwbTrainingCourseCodeFromRoute } from './dwbHelpers'
import { resolveK12TrainingProgramFromUrl } from './programHelpers'
import { isTrainingArticleRoute } from 'utils/routing/routeHelpers'
import { parseCoursePointerQuery } from './coursePointer'

export const resolveCourseNodeIdFromConnector = (connector = {}) => {
  if (!connector || typeof connector !== 'object') return null

  return (
    connector.courseNodeEntryPoint ||
    connector.course_node_entry_point ||
    connector.id ||
    null
  )
}

export const resolveCourseNodeId = ({ route, article } = {}) => {
  if (route?.courseNodeId) return route.courseNodeId

  const connector =
    article?.courseNodeConnector || article?.course_node_connector || {}

  return resolveCourseNodeIdFromConnector(connector) || ''
}

export const resolveTrainingCourseCode = ({
  programConfig,
  coursePointer,
  pathname,
}) => {
  if (programConfig?.usesBandCourseCodes && pathname) {
    const bandCourseCode = resolveDwbTrainingCourseCodeFromRoute(
      pathname,
      programConfig.contentGroupCode,
    )
    if (bandCourseCode) return bandCourseCode
  }

  const pointerCode = parseCoursePointerQuery(coursePointer).courseCode

  return programConfig?.trainingCourseCode || pointerCode || null
}

/**
 * Resolves the curriculum-service course code used for both selecting and
 * fetching the training course tree. Legacy program codes (e.g.
 * `6-8_training_tier1`) are remapped to their canonical curriculum-service
 * equivalents so Redux state keys stay aligned.
 */
export const resolveTrainingCourseCodeForTree = ({
  programConfig,
  coursePointer,
  contentGroupCode,
  pathname,
}) => {
  const rawCode = resolveTrainingCourseCode({
    programConfig,
    coursePointer,
    pathname,
  })
  if (!rawCode) return null
  return resolveCanonicalCourseCode(contentGroupCode, rawCode) || rawCode
}

export const resolveCourseCodeForTree = ({
  coursePointer,
  contentGroupCode,
  registrationCourseCode,
}) => {
  const pointerCode = parseCoursePointerQuery(coursePointer).courseCode
  const trainingCourseCode = isTrainingArticleRoute()
    ? resolveK12TrainingProgramFromUrl()?.courseTreeName ?? null
    : null
  const rawCode = trainingCourseCode || pointerCode || registrationCourseCode

  if (!rawCode) return null

  return resolveCanonicalCourseCode(contentGroupCode, rawCode) || rawCode
}
